import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Container, Heading, Text, Button, SimpleGrid, VStack, Flex, Input, HStack, FormControl } from '@chakra-ui/react';
import logo from '../assets/logo.svg';
const Feature = ({ title, text, emoji }: { title: string; text: string; emoji: string }) => {
  return (
    <VStack
      align="center"
      p="6"
      bg="mamaFuel.moss.100"
      borderRadius="lg"
      boxShadow="md"
      height="100%"
      transition="transform 0.3s"
      _hover={{ transform: 'translateY(-5px)' }}
    >
      <Text fontSize="4xl" mb="4">{emoji}</Text>
      <Heading size="md" mb="2">{title}</Heading>
      <Text textAlign="center">{text}</Text>
    </VStack>
  );
};

const Home = () => {
  return (
    <Box bg="mamaFuel.cream">
      {/* Hero Section */}
      <Box
        bg="mamaFuel.moss.100"
        py="20"
        px="4"
      >
        <Container maxW="container.xl">
          <VStack spacing="6" textAlign="center">
            <img src={logo} width="140px" alt="MommaFuel" />
            <Flex align="center" justify="center">
              <Heading
                as="h1"
                size="2xl"
                lineHeight="1.4"
              >
                MommaFuel
              </Heading>
            </Flex>
            <Heading size="lg">Friends bring YOU food after baby</Heading>
            <Text fontSize="lg" maxW="2xl">
              We'll organize everything for you.
            </Text>
            <Link to="/register">
              <Button
                size="lg"
                variant="primary"
                rounded="full"
                px="8"
                bg="mamaFuel.moss.700"
                // _hover={{ bg: 'mamaFuel.moss.700' }}
              >
                Create Your MommaFuel
              </Button>
            </Link>
          </VStack>
        </Container>
      </Box>

      {/* Features Section */}
      <Container maxW="container.xl" py="10">
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing="10">
          <Feature
            emoji="📅"
            title="Flexible Meal Schedule"
            text="Create a meal plan which activates when you are returning home."
          />
          <Feature
            emoji="🍲"
            title="Customize Your Food Suggestions"
            text="List your favorite homemade meals and restaurant options to make your recovery period delicious and stress-free."
          />
          <Feature
            emoji="🥘"
            title="Simple for Friends & Family"
            text="Easy for loved ones to select dates, provide meals, and support you during those precious first weeks of recovery."
          />
        </SimpleGrid>
        
        <Box 
          textAlign="center" 
          mt="10" 
          p="8" 
          bg="mamaFuel.moss.100" 
          borderRadius="lg"
        >
          <Heading size="md" mb="4">How It Works</Heading>
          <SimpleGrid columns={{ base: 1, md: 4 }} spacing="6">
            <VStack>
              <Text fontSize="2xl">1️⃣</Text>
              <Heading size="sm">Create Your MommaFuel</Heading>
              <Text fontSize="sm">Set up your MommaFuel with your due date and food preferences</Text>
            </VStack>
            <VStack>
              <Text fontSize="2xl">2️⃣</Text>
              <Heading size="sm">Welcome Home</Heading>
              <Text fontSize="sm">Open the meal slots when you're returning home</Text>
            </VStack>
            <VStack>
              <Text fontSize="2xl">3️⃣</Text>
              <Heading size="sm">Meals Begin</Heading>
              <Text fontSize="sm">Friends sign up for meal drop off days convenient for them</Text>
            </VStack>
            <VStack>
              <Text fontSize="2xl">4️⃣</Text>
              <Heading size="sm">Focus on Self Care</Heading>
              <Text fontSize="sm">Enjoy meals while you adjust to life with your newest little family member!</Text>
            </VStack>
          </SimpleGrid>
        </Box>
      </Container>

    </Box>
  );
};

export default Home; 